module.exports = __webpack_public_path__ + "static/media/pic8.2c04266a.jpg";